import { useFrame } from '@react-three/fiber';
import { Color } from 'three';
import React, { FC, forwardRef } from 'react';
import { useRef } from 'react';
import { Vector } from '../types';

export type BoxProps = {
  position?: Vector;
  size?: Vector;
  color?: string;
  ref?: any;
  updateMeshRef?: (ref: any) => void;
  updatePositionRef?: (ref: any, delta: number) => void;
  emissive?: string;
};

export const Box: FC<BoxProps> = forwardRef(
  (
    {
      position = [0, 0, 0] as Vector,
      size,
      color,
      updateMeshRef,
      updatePositionRef,
      emissive,
    },
    ref,
  ) => {
    const meshRef = useRef<any>();
    const positionRef = useRef<any>();
    useFrame((_, delta) => {
      if (updateMeshRef) {
        updateMeshRef(meshRef.current);
      }
      if (updatePositionRef) {
        updatePositionRef(positionRef.current, delta);
      }
    });
    return (
      <mesh ref={(ref as any) ?? positionRef} position={position}>
        <boxGeometry args={size} />
        <meshStandardMaterial
          ref={meshRef}
          color={color}
          emissive={emissive === undefined ? emissive : new Color(emissive)}
        />
      </mesh>
    );
  },
);
